import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserRulesTemplate } from 'planning-portal-library/src/lib/core/domain/models/user-rules-template';
import {
  CreateUserRulesTemplateRequest,
  EditUserRulesTemplateRequest,
} from 'planning-portal-library/src/lib/core/domain/requests/user-rules-template';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { UserRulesTemplateRepository } from 'planning-portal-library/src/lib/core/repositories/user-rules-template.repository';
import { catchError, map, mergeMap, Observable, reduce } from 'rxjs';
import { UserRulesTemplateRepositoryMapper } from './entities/user-rules-template-repository-mapper';
import { BaseResponse } from '../../shared/base.response';
import { UserRulesTemplateWebEntity } from './entities/user-rules-template.web-entity';
import { UserRulesTemplateApiUrls } from './user-rules-template-api-urls';

@Injectable({ providedIn: 'root' })
export class UserRulesTemplateWebRepository extends UserRulesTemplateRepository {
  userRulesTemplateRepositoryMapper = new UserRulesTemplateRepositoryMapper();
  environment = injectEnvironment();
  constructor(private readonly http: HttpClient) {
    super();
  }

  getUserRulesTemplatesByUserId(): Observable<UserRulesTemplate[]> {
    return this.http
      .get<BaseResponse<UserRulesTemplateWebEntity[]>>(
        `${this.environment.url}${UserRulesTemplateApiUrls.GetUserRulesTemplatesByUserId}`
      )
      .pipe(
        mergeMap(
          (response: BaseResponse<UserRulesTemplateWebEntity[]>) =>
            response.result!
        ),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.userRulesTemplateRepositoryMapper.mapFrom))
      .pipe(
        reduce(
          (items: UserRulesTemplate[], item: UserRulesTemplate) => [
            ...items,
            item,
          ],
          []
        )
      );
  }
  getUserRulesTemplatesByUserIdIncludingDefault(): Observable<
    UserRulesTemplate[]
  > {
    return this.http
      .get<BaseResponse<UserRulesTemplateWebEntity[]>>(
        `${this.environment.url}${UserRulesTemplateApiUrls.GetUserRulesTemplatesByUserIdIncludingDefault}`
      )
      .pipe(
        mergeMap(
          (response: BaseResponse<UserRulesTemplateWebEntity[]>) =>
            response.result!
        ),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.userRulesTemplateRepositoryMapper.mapFrom))
      .pipe(
        reduce(
          (items: UserRulesTemplate[], item: UserRulesTemplate) => [
            ...items,
            item,
          ],
          []
        )
      );
  }

  getUserRulesTemplateById(request: string): Observable<UserRulesTemplate> {
    return this.http
      .get<BaseResponse<UserRulesTemplateWebEntity>>(
        `${this.environment.url}${UserRulesTemplateApiUrls.GetUserRulesTemplateById}`,
        {
          params: {
            id: request,
          },
        }
      )
      .pipe(
        map(
          (response: BaseResponse<UserRulesTemplateWebEntity>) =>
            response.result!
        ),
        catchError((err) => {
          throw err;
        })
      )
      .pipe(map(this.userRulesTemplateRepositoryMapper.mapFrom));
  }

  CreateUserRulesTemplate(
    request: CreateUserRulesTemplateRequest
  ): Observable<string> {
    return this.http
      .post<BaseResponse<string>>(
        `${this.environment.url}${UserRulesTemplateApiUrls.CreateUserRulesTemplate}`,
        request
      )
      .pipe(
        map((response: BaseResponse<string>) => response.result ?? ''),
        catchError((err) => {
          throw err;
        })
      );
  }

  EditUserRulesTemplate(
    request: EditUserRulesTemplateRequest
  ): Observable<string> {
    return this.http
      .post<BaseResponse<string>>(
        `${this.environment.url}${UserRulesTemplateApiUrls.EditUserRulesTemplate}`,
        request
      )
      .pipe(
        map((response: BaseResponse<string>) => response.result ?? ''),
        catchError((err) => {
          throw err;
        })
      );
  }

  DeleteUserRulesTemplate(request: string): Observable<boolean> {
    return this.http
      .delete<BaseResponse<boolean>>(
        `${this.environment.url}${UserRulesTemplateApiUrls.DeleteUserRulesTemplatesById}`,
        {
          params: {
            id: request,
          },
        }
      )
      .pipe(
        map((data) => {
          return data.successful;
        }),
        catchError((err) => {
          throw err;
        })
      );
  }
}
